export default {
  parts: ['header', 'dialog'],
  baseStyle: {
    header: {
      fontSize: '1.5rem',
      fontWeight: 'black',
      lineHeight: '1.5rem',
      letterSpacing: '-0.025em',
      color: 'blue.900',
      pt: 6,
      pb: 1,
    },
    dialog: {
      borderWidth: 1,
      borderColor: 'gray.500',
      rounded: 6,
    },
  },
}
